import { useTheme } from "./ThemeController";

/**
 * Paint-drip curtain hung from the top of the hero.
 * - LIGHT mode: plays the white-background drip video (white blends into the
 *   white page, so only the paint shows).
 * - DARK mode: plays the black-background drip video (black blends into the
 *   dark page).
 * Both provide WebM (reliable autoplay everywhere) + H.264 MP4 fallback.
 */
export default function DripCurtain({ mode, onEnded }) {
    const { theme } = useTheme();
    // `mode` (hero-local cycle) takes precedence over global theme.
    const dark = (mode || theme) !== "light";

    const webm = dark ? "/paint/drips_black.webm" : "/paint/drips_white.webm";
    const mp4 = dark ? "/paint/drips_black.mp4" : "/paint/drips_white.mp4";
    const rate = dark ? 0.5 : 1; // slow the black paint so it feels calm
    // Both clips fill the hero edge-to-edge.
    const fit = "object-cover";

    const applyRate = (e) => {
        e.currentTarget.playbackRate = rate;
    };

    return (
        <div
            aria-hidden
            data-testid="drip-curtain-video"
            data-mode={dark ? "dark" : "light"}
            className="absolute inset-x-0 top-0 z-0 pointer-events-none overflow-hidden"
            style={{ height: "92vh" }}
        >
            <video
                key={dark ? "drip-black" : "drip-white"}
                autoPlay
                muted
                playsInline
                preload="auto"
                onLoadedMetadata={applyRate}
                onLoadedData={applyRate}
                onEnded={onEnded}
                className={`absolute inset-0 w-full h-full ${fit} object-top`}
            >
                <source src={mp4} type="video/mp4" />
                <source src={webm} type="video/webm" />
            </video>
        </div>
    );
}
